module.exports = __webpack_public_path__ + "static/media/HPVV-WhiteLogo.52ae9022.svg";